import { styled } from '@mui/material';
import { Colors } from 'library';
import States from '../../../../constants/States';

const stateAbbrs = Object.keys(States) as (keyof typeof States)[];
const stateValues = Object.values(States).map((x) => x.toLowerCase());

export function getStateAbbr(state: string) {
    const normalState = state.replaceAll('_', ' ').toLocaleLowerCase();
    const valueIndex = stateValues.indexOf(normalState);
    return stateAbbrs[valueIndex] || state;
}

export function formatStateName(state: string) {
    return state
        .replaceAll('_', ' ')
        .split(' ')
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
        .join(' ');
}

export const PageWrapper = styled('div')({
    width: '100%',
});

export const HeroSection = styled('div')({
    background: `linear-gradient(135deg, ${Colors.primary} 0%, ${Colors.primaryDarkened} 100%)`,
    padding: '40px 24px',
});

export const HeroContent = styled('div')<{ maxWidth?: number }>(({ maxWidth = 1200 }) => ({
    maxWidth,
    margin: '0 auto',
}));

export const ContentSection = styled('div')<{ maxWidth?: number }>(({ maxWidth = 1200 }) => ({
    maxWidth,
    margin: '0 auto',
    padding: '32px 24px 48px',
}));

export const PageCard = styled('div')({
    backgroundColor: Colors.white,
    borderRadius: 12,
    border: `1px solid ${Colors.lightGrey}`,
});

export const TypeChip = styled('span')<{ $variant: 'full' | 'part' }>(({ $variant }) => ({
    fontSize: 11,
    fontWeight: 600,
    fontFamily: 'Outfit',
    borderRadius: 4,
    padding: '3px 8px',
    backgroundColor: $variant === 'full' ? Colors.lightTurq : Colors.lightTerraCotta,
    color: $variant === 'full' ? Colors.turquoise : Colors.terraCotta,
}));

export const ChipRow = styled('div')({
    display: 'flex',
    gap: 6,
});

export const ApplyButton = styled('a')({
    display: 'inline-block',
    borderRadius: 20,
    padding: '10px 28px',
    fontSize: 15,
    fontWeight: 600,
    backgroundColor: Colors.turquoise,
    color: Colors.white,
    textDecoration: 'none',
    fontFamily: 'Outfit',
    transition: 'background-color 0.15s ease',
    '&:hover': {
        backgroundColor: '#008a76',
        color: Colors.white,
    },
});

export const BackLink = styled('a')({
    fontSize: 13,
    color: Colors.turquoise,
    fontFamily: 'Outfit',
    fontWeight: 500,
    textDecoration: 'none',
    textAlign: 'center' as const,
    '&:hover': {
        textDecoration: 'underline',
    },
});

export const LocationTag = styled('div')({
    fontSize: 12,
    fontWeight: 600,
    color: Colors.turquoise,
    textTransform: 'uppercase' as const,
    letterSpacing: '0.03em',
    marginBottom: 8,
    fontFamily: 'Outfit',
});

export function parseJobTypeLabels(jobType?: string): string[] {
    return jobType ? jobType.split(',').map((t) => t.trim()) : ['Full Time', 'Part Time'];
}
